import { Building, MapPin, Mail, User } from "lucide-react";
import { ApartamentoConPropietario } from "../../../../api/apartamentoService";

interface VerPropietarioModalProps {
  isOpen: boolean;
  apartamento: ApartamentoConPropietario | null;
  onClose: () => void;
}

export default function VerPropietarioModal({ isOpen, apartamento, onClose }: VerPropietarioModalProps) {
  if (!isOpen || !apartamento) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[95vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-4 sm:px-6 py-4 flex items-center justify-between z-10">
          <h3 className="text-lg sm:text-xl font-bold text-military-600 flex items-center gap-2">
            <User className="h-5 w-5 sm:h-6 sm:w-6" />
            <span>Información del Propietario</span>
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition text-2xl font-bold leading-none"
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>

        <div className="p-4 sm:p-6 space-y-4 sm:space-y-5">
          <div className="bg-gray-50 rounded-lg p-4 space-y-3">
            <h4 className="font-semibold text-gray-900 mb-3">Información del Apartamento</h4>
            
            <div className="flex items-center gap-2 text-sm text-gray-700">
              <Building size={16} className="text-gray-500" />
              <span className="font-medium">Torre:</span>
              <span>{apartamento.apt_torre_nombre || "N/A"}</span>
            </div>

            <div className="flex items-center gap-2 text-sm text-gray-700">
              <MapPin size={16} className="text-gray-500" />
              <span className="font-medium">Apartamento:</span>
              <span>{apartamento.apt_nombre}</span>
            </div>

            {apartamento.apt_piso !== undefined && (
              <div className="flex items-center gap-2 text-sm text-gray-700">
                <span className="font-medium">Piso:</span>
                <span>{apartamento.apt_piso}</span>
              </div>
            )}
          </div>

          <div className="bg-blue-50 rounded-lg p-4 space-y-3 border border-blue-200">
            <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <User size={18} className="text-blue-600" />
              Propietario
            </h4>
            
            {apartamento.apt_usuario_propietario ? (
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-sm">
                  <Mail size={16} className="text-blue-600" />
                  <span className="font-medium text-gray-700">Correo electrónico:</span>
                </div>
                <a 
                  href={`mailto:${apartamento.apt_usuario_propietario}`}
                  className="text-blue-600 hover:text-blue-800 hover:underline block pl-6 text-sm"
                >
                  {apartamento.apt_usuario_propietario}
                </a>
              </div>
            ) : (
              <p className="text-sm text-gray-500 italic">No hay información del propietario disponible</p>
            )}
          </div>

          <div className="flex justify-end pt-4 border-t border-gray-200">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-military-500 hover:bg-military-600 text-white rounded-lg font-medium transition-colors"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

